import { MapTo } from '@adobe/aem-react-editable-components';
import PaneCashBack, { PaneCashBackEditConfig } from './PaneCashBack';

export default MapTo('cob-corp-acquisition/components/creditonebank/pane-cash-back')(PaneCashBack, PaneCashBackEditConfig);